import Skeleton from 'react-loading-skeleton';
import styles from '@features/cms/components/categories/CategoryTilesBlock/components/SkeletonTile/SkeletonTile.styles';
const SkeletonTile = () => <div sx={styles.skeletonContainer}>
    <Skeleton width="100%" height="100%" sx={styles.skeletonImage} />
    <Skeleton width="100%" height="24px" sx={styles.skeletonText(false)} />
    <Skeleton width="70%" height="24px" sx={styles.skeletonText(true)} />
  </div>;
export default SkeletonTile;